
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/modules/dialog/dialog-component.kpa`,
      template: `<div class="dialog-overlay" ref="dialogOverlay"></div>`,
      style: `.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: left 0.3s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
  transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s;
  transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
}

.dialog-overlay:empty {
  display: none;
  -webkit-backdrop-filter: blur(0);
          backdrop-filter: blur(0);
  transition: left 0.2s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
  transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s;
  transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
}

.dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-box {
  position: relative;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 10;
}

.dialog-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.dialog button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.dialog-confirm {
  background-color: #4CAF50;
  color: #fff;
}

.dialog-cancel {
  background-color: #f44336;
  color: #fff;
}

.dialog-close {
  background-color: #007BFF;
  color: #fff;
}

.dialog-outside-close {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}

.dialog.dialog-modal .dialog-box {
  border: 2px solid #64c16c;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

.dialog.dialog-modal .dialog-box .dialog-close {
  position: absolute;
  top: -16px;
  right: -16px;
  background-color: #2c4143;
  color: #fff;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 24px;
  line-height: 32px;
  transition: background-color 0.3s ease 0s, color 0.3s ease 0s;
}

.dialog.dialog-modal .dialog-box .dialog-close:hover {
  background-color: #1a2628;
}

.dialog.dialog-modal .dialog-box .dialog-content {
  max-width: 80vw;
  max-height: 80vh;
  padding: 32px;
  overflow: auto;
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    mounted() {
        dialog.init();
    },
    methods: {
        openDialog(content, type, options) {
            dialog.createDialog(content, type, options);
        },
        closeAllDialogs() {
            dialog.closeAllDialogs();
        },
    },
};
 })()`
    };
  